ui-cms-stock-indices {
  display: block;

  hr {
    position: absolute;
    left: 0;
    width: 100%;
    border: 0;
    border-bottom: 1px solid $ui-grey;
  }

  .dax-box-wrapper {
    &__content {
      overflow: hidden;
      display: flex;
      flex-direction: column;

      .content-options {
        padding: 0;
        order: 1;

        @include breakpoint($medium) {
          order: 0;
        }

        &__item {
          display: inline-block;
          text-decoration: underline;
          color: $ui-blue;
          cursor: pointer;
          line-height: 2.5rem;
          transition: all ease 0.2s;
          margin-right: 1.5rem;

          @include breakpoint($small) {
            margin-right: 1.5rem;
          }

          @include breakpoint($medium) {
            margin-right: 1rem;
          }

          &.active {
            color: $ui-green;
            font-weight: $font-weight-bold;
            text-decoration: none;
          }

          &:hover {
            color: $ui-green;
          }
        }
      }

      .content-container {
        display: block;

        @include breakpoint($small) {
          display: block;
        }

        @include breakpoint($medium) {
          display: flex;
          align-items: top;
          margin-top: 1rem;
        }

        .stock-title {
          margin: 0;
          font-size: 1rem;

          @include breakpoint($small) {
            font-size: 1rem;
          }

          @include breakpoint($medium) {
            font-size: 1.5rem;
          }

          .stock-price-mobile {
            font-weight: $font-weight-bold;

            @include breakpoint($medium) {
              display: none;
            }
          }
        }

        .stock-price {
          margin: 0;
          color: $ui-blue;
          font-size: 3rem;
          font-weight: $font-weight-bold;
          line-height: normal;
          display: none;

          @include breakpoint($small) {
            display: none;
          }

          @include breakpoint($medium) {
            display: block;
          }
        }

        .stock-date {
          margin: 0;
        }

        .stock-balance {
          font-weight: $font-weight-bold;
          margin-left: 0.25rem;

          @include breakpoint($small) {
            margin-left: 0.25rem;
          }

          @include breakpoint($medium) {
            display: inline-block;
          }
        }

        &__column-info {
          width: 100%;
          margin: 1rem 0;

          @include breakpoint($small) {
            width: 100%;
            margin: 1rem 0;
          }

          @include breakpoint($medium) {
            width: 30%;
            padding-right: 1.5rem;
            margin: 0;
          }

          @include breakpoint($desktop) {
            padding-right: 1rem;
          }
        }

        &__column-chart {
          width: 100%;

          @include breakpoint($small) {
            width: 100%;
          }

          @include breakpoint($medium) {
            width: 70%;
            padding-left: 1.5rem;
          }

          @include breakpoint($desktop) {
            padding-left: 1rem;
          }
        }
      }
    }

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      min-height: 48px;

      &-preview {
        display: flex;

        .dax-box-wrapper__header-item {
          margin-right: 1.5rem;

          &:nth-child(n + 2) {
            display: none;
          }

          @include breakpoint($small) {
            &:nth-child(n + 2) {
              display: none;
            }
          }

          @include breakpoint($medium) {
            &:nth-child(n + 2) {
              display: block;
            }

            &:nth-child(n + 3) {
              display: none;
            }
          }

          @include breakpoint($desktop) {
            &:nth-child(n + 3) {
              display: block;
            }
          }

          .header-item-amount {
            font-weight: $font-weight-bold;
            margin: 0 0.5rem;
          }
        }
      }

      &-toggle {
        cursor: pointer;

        .toggle-content {
          display: flex;
          align-items: center;

          &__description {
            margin-right: 0.5rem;
            font-weight: $font-weight-normal;
            text-decoration: underline;
            color: var(--current-color-primary, $ui-blue);
            display: none;

            @include breakpoint($medium) {
              display: flex;
            }
          }

          ui-icon {
            width: 24px;
            height: 24px;
          }
        }
      }
    }

    .stock-balance {
      margin: 0;

      &.positive {
        color: $ui-green;
      }

      &.negative {
        color: $ui-red;
      }
    }

    .stock-last-day {
      margin: 0;
    }
  }

  .overlay {
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
    background: rgba($color: #fff, $alpha: 80%);

    sd-spinner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 1;
    }
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
